import { decode as base64_decode, encode as base64_encode } from "base-64";
import RootStore from "./RootStore";
import { postApi } from "../components/Utility";
import {
  action,
  computed,
  makeObservable,
  observable,
  autorun,
  runInAction,
} from "mobx";
import config from "../config";

class AssignVehicleToCompanyStore {
  total = 0;
  loading = false;
  vehicles = [];
  getVehiclesUsingCompanyId = [];
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      vehicles: observable,
      // getVehiclesUsingCompanyId: observable,
      getAssetData: action,
      addData: action,
    });
    this.rootStore = rootStore;
  }

  async addData(data) {
   
    var response = await postApi
      .getClient("")
      .put(config.NodeUrl + "/vehicle/assignNewCompany", data);
      // .put("http://localhost:3061/vehicle/assignNewCompany", data);

    return response;

  }

  async getAssetData({companyId}) {
    console.log(companyId, "id");
    const postData = { companyId: companyId, userId: 1, isadmin: -1 };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=vehicle&a=getVehicles", "postData=" + base64Input);
    // console.log(response);

    this.getVehiclesUsingCompanyId = response?.data?.data;
    return response?.data?.data


  }
}

export default AssignVehicleToCompanyStore;
